import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRemove = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#remove_svg__a)">
      <path fill="#263E6A" d="M5.5 12.5v-1h13v1z" />
    </g>
    <defs>
      <clipPath id="remove_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgRemove;
